import { guardedFetch } from '../core/navGeneration.js';
import { normalizeBrandingWebsite } from '../../../../shared/resellerBranding.js';
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

export async function mountWorkspaceBranding(host, { guid, name, base, isCurrent = () => true }) {
  let saved, draftLogo, reading = false, uploadVersion = 0;
  const current = () => host.isConnected && isCurrent();
  const url = `${base}/m5t/v5/acctGroup/${encodeURIComponent(guid)}/branding`;
  host.innerHTML = '<p role="status">Loading branding…</p>';
  const request = async options => {
    const res = await guardedFetch(url, options);
    const data = await res.json();
    if (!res.ok || !data.ok) throw new Error(data.error || 'Could not load branding.');
    return data.branding;
  };
  function preview() {
    const enabled = host.querySelector('#ws-brand-enabled').checked;
    const logo = draftLogo === undefined ? saved.logo : draftLogo;
    const footer = host.querySelector('[data-brand-preview]');
    footer.replaceChildren();
    let website = null;
    try { website = normalizeBrandingWebsite(host.querySelector('#ws-brand-website').value); } catch { /* Invalid drafts remain unlinked. */ }
    const content = document.createElement(enabled && website ? 'a' : 'span');
    content.className = 'ws-brand-identity';
    if (enabled && website) { content.href = website; content.target = '_blank'; content.rel = 'noopener noreferrer'; }
    footer.append(content);
    if (enabled && logo) { const img = document.createElement('img'); img.src = logo; img.alt = ''; content.append(img); }
    const label = document.createElement('span'); label.append('Powered by ');
    const b = document.createElement('strong'); b.textContent = enabled ? name.trim().slice(0, 160) : 'Mach Five Magnet'; label.append(b); content.append(label);
    host.querySelector('#ws-brand-remove').hidden = !logo;
  }
  host.addEventListener('branding-name-changed', event => { name = event.detail; if (host.querySelector('#ws-brand-enabled')) preview(); });
  function render() {
    draftLogo = undefined;
    host.innerHTML = `
      <style>
        .ws-brand-grid{display:grid;grid-template-columns:minmax(0,1fr) minmax(220px,.8fr);gap:28px;align-items:center}
        .ws-brand-actions [hidden]{display:none!important}
        .ws-brand-actions{display:flex;gap:12px;flex-wrap:wrap;margin:18px 0}
        .ws-brand-sample{border:1px solid var(--color-border,#D3DAE4);border-radius:14px;overflow:hidden;background:var(--color-bg,#fff)}
        .ws-brand-sample>p{margin:0;padding:24px;color:var(--color-text-muted,#4A5A78);font-size:.875rem}
        .ws-brand-footer{border-top:1px solid var(--color-border,#D3DAE4);padding:8px 12px;display:flex;justify-content:center;align-items:center;gap:7px;font-size:12px;color:var(--color-text-muted,#4A5A78)}
        .ws-brand-footer span{min-width:0;overflow-wrap:anywhere;text-align:center}
        .ws-brand-footer img{width:auto;max-width:38px;height:16px;object-fit:contain;flex:none}
        .ws-brand-identity{display:inline-flex;align-items:center;justify-content:center;gap:7px;color:inherit;text-decoration:none;max-width:100%}
        a.ws-brand-identity:hover{text-decoration:underline}
        a.ws-brand-identity:focus-visible{outline:2px solid var(--color-primary,#0072ba);outline-offset:3px}
        .ws-brand-toggle{display:flex;align-items:flex-start;gap:10px;font-weight:600}
        .ws-brand-toggle input{margin-top:4px;flex:none}
        @media(max-width:640px){.ws-brand-grid{grid-template-columns:minmax(0,1fr);gap:16px}}
      </style>
      <h2 class="settings-section__title">Magnet branding</h2>
      <p class="settings-section__desc">Your logo and organization name in the footer of your magnets and your clients’ magnets.</p>
      <div class="ws-brand-grid">
        <div>
          <label class="ws-brand-toggle"><input type="checkbox" id="ws-brand-enabled" ${saved.enabled ? 'checked' : ''}>Use your organization’s branding</label>
          <div class="ws-brand-actions">
            <button class="btn btn-secondary" type="button" id="ws-brand-upload">Upload logo</button>
            <button class="btn btn-secondary" type="button" id="ws-brand-remove">Remove logo</button>
          </div>
          <input id="ws-brand-file" type="file" accept="image/png,image/jpeg,image/gif,image/webp" hidden>
          <p class="settings-help">PNG, JPG, GIF or WebP. Up to 3 MB.</p>
          <div class="settings-field">
            <label class="settings-label" for="ws-brand-website">Website URL (optional)</label>
            <input class="settings-input" id="ws-brand-website" type="url" maxlength="2048" placeholder="https://yourcompany.com" value="${esc(saved.website_url || '')}" aria-describedby="ws-brand-website-help">
            <p class="settings-help" id="ws-brand-website-help">Opens when someone clicks your footer logo or name. Leave blank for no link.</p>
          </div>
        </div>
        <div class="ws-brand-sample"><p>Footer preview</p><div class="ws-brand-footer" data-brand-preview></div></div>
      </div>
      <p class="settings-error" role="alert" id="ws-brand-error"></p>
      <p class="settings-help" role="status" id="ws-brand-status"></p>
      <div class="settings-save-row"><button class="btn btn-primary" type="button" id="ws-brand-save">Save branding</button></div>`;
    const error = host.querySelector('#ws-brand-error');
    const status = host.querySelector('#ws-brand-status');
    host.querySelector('#ws-brand-enabled').addEventListener('change', preview);
    host.querySelector('#ws-brand-website').addEventListener('input', () => { host.querySelector('#ws-brand-website').removeAttribute('aria-invalid'); preview(); });
    host.querySelector('#ws-brand-upload').addEventListener('click', () => host.querySelector('#ws-brand-file').click());
    host.querySelector('#ws-brand-remove').addEventListener('click', () => { uploadVersion++; reading = false; draftLogo = null; host.querySelector('#ws-brand-save').disabled = false; preview(); });
    host.querySelector('#ws-brand-file').addEventListener('change', async event => {
      const file = event.target.files?.[0]; event.target.value = ''; if (!file) return;
      error.textContent = ''; status.textContent = '';
      if (!['image/png','image/jpeg','image/gif','image/webp'].includes(file.type) || file.size > 3*1024*1024) { error.textContent = 'Choose a PNG, JPG, GIF or WebP image under 3 MB.'; return; }
      const version = ++uploadVersion;
      reading = true; host.querySelector('#ws-brand-save').disabled = true;
      try {
        const result = await new Promise((resolve,reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(file); });
        if (!current() || version !== uploadVersion) return;
        draftLogo = result; preview();
      } catch { if (current()) error.textContent = 'Could not read that image. Choose another file.'; }
      finally { if (current() && version === uploadVersion) { reading = false; host.querySelector('#ws-brand-save').disabled = false; } }
    });
    host.querySelector('#ws-brand-save').addEventListener('click', async () => {
      if (reading || !current()) return;
      error.textContent = ''; status.textContent = '';
      const websiteInput = host.querySelector('#ws-brand-website');
      let website;
      try { website = normalizeBrandingWebsite(websiteInput.value); }
      catch (err) { error.textContent = err.message; websiteInput.setAttribute('aria-invalid', 'true'); websiteInput.focus(); return; }
      const controls = [...host.querySelectorAll('button,input')]; controls.forEach(el => el.disabled = true);
      try {
        saved = await request({ method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled: host.querySelector('#ws-brand-enabled').checked, revision: saved.revision, website_url: website, ...(draftLogo !== undefined ? { logo: draftLogo } : {}) }) });
        if (!current()) return;
        draftLogo = undefined; websiteInput.value = saved.website_url || ''; preview(); status.textContent = 'Branding saved. Website changes appear on a new page load within five minutes.';
      } catch (err) { if (current()) error.textContent = err.message || 'Could not save branding. Your changes are still here.'; }
      finally { if (current()) controls.forEach(el => el.disabled = false); }
    });
    preview();
  }
  try { saved = await request(); if (current()) render(); }
  catch (err) { if (current()) { host.innerHTML = `<p role="alert">${esc(err.message)}</p><button class="btn btn-secondary" type="button">Try again</button>`; host.querySelector('button').onclick = () => mountWorkspaceBranding(host, {guid,name,base,isCurrent}); } }
}
